module.exports = __webpack_public_path__ + "img/bgTitle4.50909dee.png";